<div class="btn-group me-3">
    <div class="btn-group" ngbDropdown role="group" aria-label="Button group with nested dropdown">
        <button class="btn" ngbDropdownToggle>
            <img class="user-img" src="../../assets/images/male.svg" />{{userName}}</button>

        <div ngbDropdownMenu aria-labelledby="navbarDropdown2" class="dropdown-menu dropdown-menu-right">
            <a ngbDropdownItem (click)="logOut()">Log Out</a>
        </div>
    </div>
</div>